package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.db.SessionData
import com.neurobs.js.ccab.CCABServer
import com.neurobs.js.controller.{AdminListAdapter, AdminListController, AdminPanelDelegate}
import com.neurobs.js.dom.RecordTableView.CommandLinkCell
import com.neurobs.js.view.Gui
import com.neurobs.js.util.StringUtilities.{dateString, dateTimeString}

import scala.concurrent.{Future, Promise}

class TestSessionListController(accountId: Long, accountName: String, gui: Gui) extends AdminListAdapter[SessionData] {

	override def title = s"Account $accountId ($accountName) Test Sessions"

	override def itemName = "Test Session"

	override def columnHeaders = Seq(
		"Created",
		"Start Time",
		"Account Id",
		"Study Id",
		"Acct Subject Id",
		"Station User Id",
		"Admin User Id",
		"Station",
		"Access GUID",
		"Subject GUID",
		"Properties",
		""
	)

	override def itemRow(a: SessionData, delegate: Option[AdminPanelDelegate], controller: AdminListController[SessionData]) = Seq(
		dateString(a.createdAt),
		dateTimeString(a.startTime),
		a.accountId.toString,
		a.studyId.toString,
		a.accountSubjectId.toString,
		a.stationUserId.toString,
		a.adminUserId.map(_.toString).getOrElse(""): String,
		a.stationName,
		a.accessGuid.noBracketsString,
		a.subjectGuid.noBracketsString,
		a.properties.getOrElse(""): String,
		CommandLinkCell(text = "runs", () => delegate.foreach(_.newPanel(TestRunListController(a.id, gui))))
	)

	override val create = None

	override def get(): Future[Either[String, Seq[SessionData]]] = {
		val promise = Promise[Either[String, Seq[SessionData]]]
		CCABServer.getTestSessions(accountId) {
			case Left(error) => promise.success(Left(error.message))
			case Right(list) => promise.success(Right(list))
		}
		promise.future
	}
}

object TestSessionListController {
	def apply(gui: Gui, accountId: Long, accountName: String): AdminListController[SessionData] = new AdminListController[SessionData](new TestSessionListController(accountId, accountName, gui))
}